<template>
  <div class="transact-wrapper main-section" v-if="isShowOnFixed || !isMobile">
    <div class="btn-area">
      <button @click="marginModal = true">
        {{ $t(`trading.table.${userSelectInfo.marginType}`) }}
      </button>
      <button @click="leverageModal = true">{{ userSelectInfo.leverage }}x</button>
      <div class="mo close_btn" @click="isShowOnFixed = false">
        {{ $t("trading.common.close") }}
      </div>
    </div>
    <Tab :tabItems="tabItems" @tabSelectHandler="tabSelectHandler" />
    <div class="cal-row">
      <div class="row-info">
        <p>{{ $t("trading.transact.avbl") }}</p>
        <span>{{ formatNumberWithComma(userWallet.avbl, 4) }} USDT</span>
      </div>
      <img
        :src="CalWhiteImg"
        alt="liquidation Price"
        @click="calcualteModal = true"
      />
    </div>
    <div class="price-info" v-if="activeTab?.key === 'limit'">
      <label for="price">{{ $t("trading.table.price") }}</label>
      <div class="pr">
        <input
          type="text"
          v-model="userSelectInfo.priceInput"
          @input="numberFormatter($event, 'price')"
          @blur="numberFormatter($event, 'price')"
        />
        <!-- <div
          class="ab size price"
          @mouseenter="isShowPrice = true"
          @mouseleave="isShowPrice = false"
        >
          <p class="">{{ userSelectInfo.percent }}</p>
          <img
            class=""
            src="@/assets/images/components/trading/icon_select_arrow.png"
            alt="arrow-down"
          />
        </div>
        <div
          class="ab dropdown drop-price"
          v-if="isShowPrice"
          @mouseenter="isShowPrice = true"
          @mouseleave="isShowPrice = false"
        >
          <ul>
            <li v-for="item in percentItems" :key="item.key" @click="selectPricePercentType(item)">
              {{ item.label }}
            </li>
          </ul>
        </div> -->
        <p class="ab">USDT</p>
      </div>
    </div>
    <div class="price-info">
      <label for="size">{{ $t("trading.table.size") }}</label>
      <div class="pr">
        <input
          type="text"
          v-model="userSelectInfo.sizeInput"
          @input="sizeNumberCheck"
          @blur="sizeNumberCheck"
        />
        <div
          class="ab size"
          @mouseenter="isShowSize = true"
          @mouseleave="isShowSize = false"
        >
          <p class="">{{ userSelectInfo.sizeType }}</p>
          <img
            class=""
            src="@/assets/images/components/trading/icon_select_arrow.png"
            alt="arrow-down"
          />
        </div>
        <div
          class="ab dropdown"
          v-if="isShowSize"
          @mouseenter="isShowSize = true"
          @mouseleave="isShowSize = false"
        >
          <ul>
            <li v-for="item in sizeItems" :key="item" @click="selectSizeType(item)">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="sliders" @click="handleClick">
      <div
        v-for="point in points"
        :key="point"
        class="tick"
        :style="{ left: point + '%' }"
      ></div>
      <div class="track" :style="{ width: position + '%' }"></div>
      <div
        class="marker"
        @mousedown="handleMouseDown"
        :style="{ left: position + '%' }"
      ></div>
    </div>
    <div class="scale">
      <span>1%</span>
      <span style="left: 25%">25%</span>
      <span style="left: 50%">50%</span>
      <span style="left: 75%">75%</span>
      <span style="left: 100%">100%</span>
    </div>
    <div class="buysell">
      <p>
        {{ $t("trading.table.buy")
        }}<span
          >{{ formatNumberWithComma(buyAmount) }} {{ userSelectInfo.sizeType }}</span
        >
      </p>
      <p>
        {{ $t("trading.table.sell")
        }}<span
          >{{ formatNumberWithComma(sellAmount) }} {{ userSelectInfo.sizeType }}</span
        >
      </p>
    </div>
    <div class="gray-line"></div>
    <div class="row-info">
      <input type="checkbox" id="tpsl" v-model="userSelectInfo.isTpsl" />
      <label for="tpsl"></label>
      <span>TP/SL</span>
    </div>
    <div class="price-info" v-if="userSelectInfo.isTpsl">
      <label for="tp">{{ $t("trading.transact.tp") }}</label>
      <input
        type="text"
        id="tp"
        v-model="userSelectInfo.tp"
        @input="numberFormatter($event, 'tp')"
      />
    </div>
    <div class="price-info" v-if="userSelectInfo.isTpsl">
      <label for="sl">{{ $t("trading.transact.sl") }}</label>
      <input
        type="text"
        id="sl"
        v-model="userSelectInfo.sl"
        @input="numberFormatter($event, 'sl')"
      />
    </div>
    <div class="btn-items">
      <button class="btn-plus" :disabled="isFetch" @click="handleOrderSubmit('buy')">
        {{ $t("trading.table.buy") }} / {{ $t("trading.table.long") }}
      </button>
      <button class="btn-minus" :disabled="isFetch" @click="handleOrderSubmit('sell')">
        {{ $t("trading.table.sell") }} / {{ $t("trading.table.short") }}
      </button>
    </div>
    <div class="info">
      <div class="long-info">
        <!-- <p>
          Liq Price<span>{{ buyLiqPrice }} USDT</span>
        </p> -->
        <p>
          {{ $t("trading.transact.cost")
          }}<span>{{ formatNumberWithComma(buyCost) }} USDT</span>
        </p>
        <p>
          {{ $t("trading.transact.max")
          }}<span>{{ formatNumberWithComma(buyMax) }} {{ userSelectInfo.sizeType }}</span>
        </p>
      </div>
      <div class="short-info">
        <!-- <p>
          Liq Price<span>{{ sellLiqPrice }} USDT</span>
        </p> -->
        <p>
          {{ $t("trading.transact.cost")
          }}<span>{{ formatNumberWithComma(sellCost) }} USDT</span>
        </p>
        <p>
          {{ $t("trading.transact.max")
          }}<span
            >{{ formatNumberWithComma(sellMax) }} {{ userSelectInfo.sizeType }}</span
          >
        </p>
      </div>
    </div>
    <ModalMargin
      :isVisible="marginModal"
      :marginType="userSelectInfo.marginType"
      @closeDialogHandler="closeMarginDialog"
    />
    <ModalLeverage
      :isVisible="leverageModal"
      :leverage="userSelectInfo.leverage"
      @closeDialogHandler="closeLeverageDialog"
    />
    <ModalLiqPrice
      :isVisible="calcualteModal"
      :select-ticker="ticker"
      @closeDialogHandler="closeLiqPriceDialog"
    />
  </div>
  <div class="fixed-btn" v-else>
    <div class="btn-items">
      <button class="btn-plus" @click="isShowOnFixed = true">
        {{ $t("trading.table.buy") }} / {{ $t("trading.table.long") }}
      </button>
      <button class="btn-minus" @click="isShowOnFixed = true">
        {{ $t("trading.table.sell") }} / {{ $t("trading.table.short") }}
      </button>
    </div>
  </div>
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :content="alertDialog.content"
    @closeDialogHandler="alertDialog.isVisible = false"
    :is-btn="true"
  />
</template>

<script setup>
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import ModalMargin from "./modal/ModalMargin.vue";
import ModalLeverage from "./modal/ModalLeverage.vue";
import ModalLiqPrice from "./modal/ModalLiqPrice.vue";
import Tab from "../common/tab/Tab.vue";
import CalBlackImg from "@/assets/images/components/trading/cal_black.png";
import CalWhiteImg from "@/assets/images/components/trading/cal_white.png";
import { useStore } from "vuex";
import { computed, onBeforeUnmount, onMounted, ref, watch, defineProps } from "vue";
import {
  formatDecimal,
  formatNumberWithComma,
  inputBlurNumCheck,
  inputNumCheck,
  isOrderValid,
  isTpslValid,
} from "@/utils/order";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const route = useRoute();
const { t } = useI18n();
const props = defineProps({
  refetchOpenOrderList: {
    type: Function,
    required: true,
  },
  refetchPositionList: {
    type: Function,
    required: true,
  },
});
const store = useStore();
const BUY_SAFETY_BUFFER = 0.99;
const SELL_SAFETY_BUFFER = 0.99;
const SAFETY_BUFFER = 0.99;
const points = [0, 24, 49, 74, 99];
// const points = [0, 25, 50, 75, 100];
const alertDialog = ref({
  isVisible: false,
  content: "",
});
const sizeItems = ref(["USDT", "XRP"]);
const percentItems = ref([
  {key : "-5" , label : "-5%"},
  {key : "-4" , label : "-4%"},
  {key : "-3" , label : "-3%"},
  {key : "-2" , label : "-2%"},
  {key : "-1" , label : "-1%"},
  {key : "0" , label : "0%"},
  {key : "1" , label : "+1%"},
  {key : "2" , label : "+2%"},
  {key : "3" , label : "+3%"},
  {key : "4" , label : "+4%"},
  {key : "5" , label : "+5%"},
]);
const sizePercent = ref(0);
const position = ref(sizePercent.value - 1);
const isShowOnFixed = ref(false);
const dragging = ref(false);
const marginModal = ref(false);
const leverageModal = ref(false);
const calcualteModal = ref(false);
const isShowSize = ref(false);
const isShowPrice = ref(true);
const isFetch = ref(false);
const tabItems = ref([
  { key: "limit", value: t("trading.table.limit"), isActive: true },
  { key: "market", value: t("trading.table.market"), isActive: false },
]);
const userSelectInfo = ref({
  marginType: "cross",
  leverage: 1,
  priceInput: null,
  sizeInput: null,
  sizeType: sizeItems.value[0],
  isTpsl: false,
  tp: null,
  sl: null,
  percent : "0%",
});
const maintenanceMarginRate = computed(() => 0.01);
const symbolData = computed(() => store.state.transact.symbolData);
const userWallet = computed(() => store.state.account.userWallet);
const isMobile = computed(() => store.state.account.isMobile);
const ticker = computed(() => store.state.transact.ticker);
const lastPrice = computed(() => store.state.transact.lastPrice);
const bidPrice = computed(() => store.state.transact.bidPrice);
const askPrice = computed(() => store.state.transact.askPrice);
const coinPrice = computed(() => store.state.transact.coinPrice);
const reCode = computed(() => store.state.transact.reCode);
const countryCode = computed(() => store.state.transact.countryCode);
const activeTab = computed(() => tabItems.value.find((v) => v.isActive));
const userNo = computed(() => store.state.userInfo.userInfo.user_no);
const userState = computed(() => store.state.account.userState);
const positionList = computed(() => store.state.user_history.positionList);
const orderbookPrice = computed(() => store.state.transact.orderbookPrice);
const isPercentInput = computed(() => {
  const input = userSelectInfo.value.sizeInput;
  return typeof input === "string" && input.includes("%");
});

const parsedSizeValue = computed(() => {
  if (isPercentInput.value) {
    const percent = parseFloat(userSelectInfo.value.sizeInput.replace("%", ""));
    return percent / 100;
  } else {
    return parseFloat(userSelectInfo.value.sizeInput);
  }
});

const changePositionLeverage = () => {
  const samePosition = positionList.value?.find((v) => v.symbol === ticker.value);
  return samePosition?.leverage || userSelectInfo.value.leverage;
};
const changePositionMarginType = () => {
  const samePosition = positionList.value?.find((v) => v.symbol === ticker.value);
  return samePosition?.margin_type || userSelectInfo.value.marginType;
};
const buyAmount = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
  return calculateAmount(price, BUY_SAFETY_BUFFER, false, false, true);
});

const sellAmount = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : bidPrice.value;
  return calculateAmount(price, SELL_SAFETY_BUFFER, false, false, true);
});

const buyMax = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
  return calculateAmount(price, BUY_SAFETY_BUFFER, true);
});

const sellMax = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : bidPrice.value;
  return calculateAmount(price, SELL_SAFETY_BUFFER, true);
});

const buyCost = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
  return calculateAmount(price, BUY_SAFETY_BUFFER, false, true, false);
});
const sellCost = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : bidPrice.value;
  return calculateAmount(price, SELL_SAFETY_BUFFER, false, true, false);
});
const buyCostNoBuff = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
  return calculateAmount(price, null, false, true, false);
});
const sellCostNoBuff = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : bidPrice.value;
  return calculateAmount(price, null, false, true, false);
});
const buyAmountNoLev = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
  // return calculateAmount(price, null, false, false, false);
  return originalAmount(price);
});
const sellAmountNoLev = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : bidPrice.value;
  // return  calculateAmount(price, null, false, false, false);
  return originalAmount(price);
});

const buyAmountNoBuff = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
  return calculateReqAmount(price);
});
const sellAmountNoBuff = computed(() => {
  const price =
    activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : bidPrice.value;
  return calculateReqAmount(price);
});

// const buyLiqPrice = computed(() => {
//   const price =
//     activeTab.value.key === "limit" ? userSelectInfo.value.priceInput : askPrice.value;
//   calculateLiqPrice(askPrice.value, "buy")});
// const sellLiqPrice = computed(() => calculateLiqPrice(bidPrice.value, "sell"));

function processInput(inputValue, sizeType) {
  const value = parseFloat(inputValue);
  if (isNaN(value)) {
    return inputValue;
  }
  return sizeType === "coin"
    ? formatDecimal(value, symbolData.value.quantityPrecision)
    : formatDecimal(value, symbolData.value.pricePrecision);
}

function calculateAmount(
  price,
  safetyBuffer,
  isMax = false,
  isCost = false,
  isLeverage = true
) {
  const leverage = userSelectInfo.value.leverage || 1;
  const parsedValue = parsedSizeValue.value;
  const buffer = safetyBuffer ? safetyBuffer : 1;
  if (!parsedValue || !price) return 0;

  if (isMax) {
    if (userSelectInfo.value.sizeType === "USDT") {
      // Max USDT 계산
      const maxAmount = userWallet.value.avbl * leverage * buffer;
      return processInput(maxAmount, "USDT");
    } else {
      // Max coin 계산
      const maxAmount = (userWallet.value.avbl * leverage * buffer) / price;
      return processInput(maxAmount, "coin");
    }
  }
  if (isCost) {
    // const coinAmount = isPercentInput.value
    //   ? ((userWallet.value.avbl * parsedValue) / price) * buffer
    //   : (parsedValue / price / leverage) * buffer;
    // const usdtAmount = coinAmount * price;
    // return processInput(usdtAmount, "USDT");
    // Cost는 무조건 USDT 금액으로 계산, leverage 반영 안 함
    let coinAmount;
    if (userSelectInfo.value.sizeType === "USDT") {
      coinAmount = isPercentInput.value
        ? ((userWallet.value.avbl * parsedValue) / price) * buffer
        : (parsedValue / price / leverage) * buffer;
    } else {
      coinAmount = isPercentInput.value
        ? ((userWallet.value.avbl * parsedValue) / price) * buffer
        : (parsedValue / leverage) * buffer;
    }

    const usdtAmount = coinAmount * price;
    return processInput(usdtAmount, "USDT");
  }
  if (userSelectInfo.value.sizeType === "USDT") {
    const coinAmount = isPercentInput.value
      ? ((userWallet.value.avbl * parsedValue * (isLeverage ? leverage : 1)) / price) *
        buffer
      : ((parsedValue * (isLeverage ? leverage : 1)) / price) * buffer;

    const usdtAmount = coinAmount * price;
    return processInput(usdtAmount, "USDT");
  } else {
    const coinAmount = isPercentInput.value
      ? ((userWallet.value.avbl * (isLeverage ? leverage : 1)) / price) *
        parsedValue *
        buffer
      : parsedValue * buffer;
    return processInput(coinAmount, "coin");
  }
}

function originalAmount(price) {
  const parsedValue = parsedSizeValue.value;
  if (userSelectInfo.value.sizeType === "USDT") {
    const usdtAmount = isPercentInput.value
      ? userWallet.value.avbl * parsedValue
      : parsedValue;
    return processInput(usdtAmount, "USDT");
  } else {
    const coinAmount = isPercentInput.value
      ? (userWallet.value.avbl / price) * parsedValue
      : parsedValue;
    return processInput(coinAmount, "coin");
  }
}

function calculateReqAmount(price) {
  const leverage = userSelectInfo.value.leverage || 1;
  const parsedValue = parsedSizeValue.value;
  const isLeverage = isPercentInput.value; // % 있을 때에만, 레버리지 곱해서 보내기
  if (!parsedValue || !price) return 0;

  if (userSelectInfo.value.sizeType === "USDT") {
    const coinAmount = isPercentInput.value
      ? (userWallet.value.avbl * parsedValue * (isLeverage ? leverage : 1)) / price
      : (parsedValue * (isLeverage ? leverage : 1)) / price;

    const usdtAmount = coinAmount * price;
    return processInput(usdtAmount, "USDT");
  } else {
    const coinAmount = isPercentInput.value
      ? ((userWallet.value.avbl * (isLeverage ? leverage : 1)) / price) * parsedValue
      : parsedValue;
    return processInput(coinAmount, "coin");
  }
}

// LiqPrice 계산 함수
// function calculateLiqPrice(price, type) {
//   const leverage = userSelectInfo.value.leverage;
//   const marginType = userSelectInfo.value.marginType;
//   if (!price || !leverage) return "--";
//   let liq;
//   if(marginType === 'isolated'){
//     liq =
//     type === "buy"
//       ? (price * leverage) / (leverage + 1)
//       : (price * leverage) / (leverage - 1);
//   }else {

//   }

//   // ? price * (1 - 1 / leverage - maintenanceMarginRate.value)
//   // : price * (1 + 1 / leverage + maintenanceMarginRate.value);
//   return liq.toFixed(2);
// }

const fetchAll = async () => {
  await store.dispatch("account/fetchUserWallet");
  await store.dispatch("user_history/fetchAllHistory", userNo.value);
};

const tabSelectHandler = (payload) => {
  tabItems.value.forEach((t) => {
    t.isActive = payload === t.key;
  });
  sizePercent.value = 0;
  updatePosition();
  userSelectInfo.value.tp = null;
  userSelectInfo.value.sl = null;
  userSelectInfo.value.priceInput = coinPrice.value;
};

const selectSizeType = (item) => {
  userSelectInfo.value.sizeType = item;
  sizePercent.value = 0;
  updatePosition();
  store.commit("transact/setSizeType", item);
  store.dispatch("transact/getCoinPrice");
};

const getSymbolList = async () => {
  console.log('ticker',ticker.value);
  sizeItems.value.pop();
  sizeItems.value.push(ticker.value);
  if (userSelectInfo.value.sizeType !== "USDT") {
    userSelectInfo.value.sizeType = ticker.value;
  }
};
const handleError = async () => {
  if (reCode.value !== 0) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t(`trading.error.${reCode.value}`);
  } else {
    await fetchAll();
    sizePercent.value = 0;
    updatePosition();
    userSelectInfo.value.sizeInput = 0;
  }
};
const handleOrderSubmit = async (type) => {
  if (isFetch.value) return;
  if (!userNo.value) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.error.105");
    return;
  }
  if (!userState.value) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.common.sts");
    return;
  }
  isFetch.value = true;
  const cost = type === "buy" ? buyCostNoBuff.value : sellCostNoBuff.value;
  const amount = type === "buy" ? buyAmountNoLev.value : sellAmountNoLev.value;
  const amountNoBuff = type === "buy" ? buyAmountNoBuff.value : sellAmountNoBuff.value;
  const isTpsl = userSelectInfo.value.isTpsl;
  const tp = userSelectInfo.value.tp;
  const sl = userSelectInfo.value.sl;
  const price =
    activeTab.value.key == "limit" ? userSelectInfo.value.priceInput : lastPrice.value;
  const sizeType = userSelectInfo.value.sizeType;
  if (
    !userSelectInfo.value.sizeInput ||
    parseFloat(cost) > parseFloat(userWallet.value.avbl) * userWallet.value.leverage
  ) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.transact.caution01");
    isFetch.value = false;
    return;
  }

  const isValid =
    sizeType === "USDT"
      ? isOrderValid(symbolData.value, null, amount, activeTab.value.key)
      : isOrderValid(symbolData.value, amount, null, activeTab.value.key);

  const minQty =
    activeTab.value.key == "limit"
      ? symbolData.value?.limitMinQty
      : symbolData.value?.marketMinQty;
  const minNotional = symbolData.value?.minNotional;
  const tpValid = !tp || isTpslValid(tp, symbolData.value, "tp", price, type);
  const slValid = !sl || isTpslValid(sl, symbolData.value, "sl", price, type);
  const tpslIsVaild = tpValid && slValid;
  if (!isValid) {
    alertDialog.value.isVisible = true;
    if (sizeType === "USDT") {
      alertDialog.value.content = t("trading.transact.caution02", {
        no: minQty,
        ticker: ticker.value,
      });
    }
    alertDialog.value.content = t("trading.transact.caution03", { no: minNotional });
    isFetch.value = false;
    return;
  }
  if (isTpsl && !tpslIsVaild) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.transact.caution04");
    isFetch.value = false;
    return;
  }

  let orderInfo = {
    type,
    user_no: userNo.value,
    symbol: ticker.value,
    margin_type: userSelectInfo.value.marginType === "cross" ? 1 : 0,
    leverage: userSelectInfo.value.leverage,
  };

  if (userSelectInfo.value.sizeType === "USDT") {
    orderInfo.usdt = amountNoBuff;
  } else {
    orderInfo.amount = amountNoBuff;
  }

  if (activeTab.value.key == "limit") {
    orderInfo.price = price;
  }

  if (isTpsl) {
    orderInfo.tp = tp ? tp : 0;
    orderInfo.sl = sl ? sl : 0;
  }

  store.commit("transact/setOrderInfo", orderInfo);
  if (activeTab.value.key == "limit") {
    await store.dispatch("transact/fetchPostLimitOrder");
  } else {
    await store.dispatch("transact/fetchPostMarketOrder");
  }

  await handleError();
  isFetch.value = false;
};

const closeMarginDialog = (key) => {
  if (key) {
    userSelectInfo.value.marginType = key;
  }
  marginModal.value = false;
};

const closeLeverageDialog = (key) => {
  if (key) {
    userSelectInfo.value.leverage = key;
  }
  leverageModal.value = false;
};

const closeLiqPriceDialog = (key) => {
  calcualteModal.value = false;
};

const updatePosition = () => {
  position.value = sizePercent.value - 1;
  if (sizePercent.value === 0) {
    position.value = 0;
    userSelectInfo.value.sizeInput = null;
  } else {
    if (sizePercent.value > 100) {
      sizePercent.value = 100;
    }
    if (sizePercent.value < 1) {
      sizePercent.value = 1;
    }
    userSelectInfo.value.sizeInput = `${sizePercent.value}%`;
  }
};

const handleClick = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const percent = (clickX / rect.width) * 100;
  sizePercent.value = Math.round(percent) + 1;
  updatePosition();
};

const handleMouseDown = () => {
  dragging.value = true;
};

const handleMouseMove = (e) => {
  if (!dragging.value) return;

  const slider = document.querySelector(".sliders");
  const rect = slider.getBoundingClientRect();
  const moveX = e.clientX - rect.left;
  const percent = (moveX / rect.width) * 100;
  sizePercent.value = Math.min(Math.max(Math.round(percent) + 1, 1), 100);
  updatePosition();
};

const sizeNumberCheck = (e) => {
  sizePercent.value = 0;
  updatePosition();
  let value = e.target.value;
  const evtType = e.type;
  let formattedValue;
  if (value.includes("%")) {
    e.target.value = "";
    return;
  }
  const precision =
    userSelectInfo.value.sizeType === "USDT"
      ? symbolData.value.pricePrecision
      : symbolData.value.quantityPrecision;
  if (evtType === "input") {
    formattedValue = inputNumCheck(value, precision);
  } else {
    if (userSelectInfo.value.sizeType === "USDT") {
      const maxPrice = formatDecimal(
        parseFloat(userWallet.value.avbl) * userSelectInfo.value.leverage,
        precision
      );
      let price = parseFloat(value);
      if (price > maxPrice) price = maxPrice;
      formattedValue = price;
    } else {
      let maxAmount;
      if (activeTab.value.key === "limit") {
        maxAmount = formatDecimal(
          parseFloat(
            (userWallet.value.avbl * userSelectInfo.value.leverage) /
              userSelectInfo.value.priceInput
          ),
          precision
        );
      } else {
        maxAmount = formatDecimal(
          parseFloat(
            (userWallet.value.avbl * userSelectInfo.value.leverage) / lastPrice.value
          ),
          precision
        );
      }
      let amount = parseFloat(value);
      if (amount > parseFloat(maxAmount)) amount = maxAmount;
      formattedValue = amount;
    }
  }
  if (isNaN(formattedValue)) {
    value = null;
  } else {
    value = formattedValue;
    userSelectInfo.value.sizeInput = value;
  }
};
const numberFormatter = (e, type) => {
  let value = e.target.value;
  const evtType = e.type;
  let formattedValue;
  if (evtType === "input") {
    formattedValue = inputNumCheck(value, symbolData.value.pricePrecision);
  } else {
    const orderPrice = userSelectInfo.value.priceInput;
    formattedValue = inputBlurNumCheck(value, symbolData.value, type, orderPrice);
  }

  value = formattedValue;
  if (type === "price") {
    userSelectInfo.value.priceInput = value;
  }
  if (type === "tp") {
    userSelectInfo.value.tp = value;
  }
  if (type === "sl") {
    userSelectInfo.value.sl = value;
  }
};

const handleMouseUp = () => {
  dragging.value = false;
};

const selectPricePercentType = (v) => {
  const n = parseFloat(v.key) / 100;
  const p = lastPrice.value * (1 + n);
  const formattedValue = inputNumCheck(String(p), symbolData.value.pricePrecision);
  userSelectInfo.value.priceInput = formattedValue;
  userSelectInfo.value.percent = v.label;
}
watch(ticker, async () => {
  console.log('aaaaaa')
  if(!countryCode.value) return;
  await store.dispatch("transact/getCoinPrice");
  await store.dispatch("transact/getSymbolPrecision");
  userSelectInfo.value.priceInput = coinPrice.value;
  userSelectInfo.value.tp = null;
  userSelectInfo.value.sl = null;
  userSelectInfo.value.leverage = changePositionLeverage();
  userSelectInfo.value.marginType = changePositionMarginType();
  sizePercent.value = 0;
  updatePosition();
  await getSymbolList();
});
watch(positionList, () => {
  userSelectInfo.value.leverage = changePositionLeverage();
  userSelectInfo.value.marginType = changePositionMarginType();
});
watch(
  () => countryCode.value,
  async () => {
    await store.dispatch("transact/getCoinPrice");
    await store.dispatch("transact/getSymbolPrecision");
    userSelectInfo.value.priceInput = coinPrice.value;
    await getSymbolList();
  }
);
watch(
  orderbookPrice, ()=>{
    userSelectInfo.value.priceInput = orderbookPrice.value;
  }
)
watch(
  isShowOnFixed, ()=>{
    const  body = document.querySelector('body');
    if(isShowOnFixed.value){
      body.style.overflow = "hidden";
    }else{
      body.style.overflow = "auto";
    }
  }
)
onMounted(async () => {
  await getSymbolList();
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);
});
onBeforeUnmount(() => {
  window.removeEventListener("mousemove", handleMouseMove);
  window.removeEventListener("mouseup", handleMouseUp);
  const  body = document.querySelector('body');
  body.style.overflow = "auto";
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/trading/common.scss";
@import "@/assets/scss/components/trading/transactUserView.scss";
</style>